import React from 'react';

import Layout from '../components/layout';
import SEO from '../components/seo';
import CourseOverviewSection from '../components/whyItWorks/courseOverviewSection';
import JoinTheRevolutionSection from '../components/whyItWorks/joinTheRevolutionSection';
import MatrixSection from '../components/whyItWorks/matrixSection';
import ProvenSolutionSection from '../components/whyItWorks/provenSolutionSection';
import TeenMentalHealthSection from '../components/whyItWorks/teenMentalHealthSection';
import WhereYouFocusSection from '../components/whyItWorks/whereYouFocusSection';
import WhyItWorksHeader from '../components/whyItWorks/whyItWorksHeader';

const WhyItWorksPage: React.FC = () => {
  return (
    <Layout>
      <SEO title="Why it Works" />
      <WhyItWorksHeader />
      <MatrixSection />
      <WhereYouFocusSection />
      <TeenMentalHealthSection />
      <ProvenSolutionSection />
      <CourseOverviewSection />
      <JoinTheRevolutionSection />
    </Layout>
  );
};

export default WhyItWorksPage;
